module.exports = __webpack_public_path__ + "img/23_14.e9e244a6.png";